import { AGraphEdge } from '../../../core/Edge';

export class PostureMapEdge extends AGraphEdge {}
